import React from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic";
import { isXavierThemeV2Enabled } from "../../utils/FeatureFlags";
import "../../../_metronic/_assets/sass/pages/error/error-4.scss";
import "./XavierError.css";

export default function ErrorPage() {
  if (isXavierThemeV2Enabled()) {
    return (
      <section className="xv-error-page">
        <span>404</span>
        <h1>Página não encontrada</h1>
        <p>
          Desculpe, a página que você procura não existe, foi movida ou não
          está disponível para o seu perfil.
        </p>
        <Link to="/admin">Voltar ao início</Link>
      </section>
    );
  }

  return (
    <>
      <div className="kt-grid kt-grid--ver kt-grid--root" style={{ height: "calc(100vh - 41px)" }}>
        <div
          className="kt-grid__item kt-grid__item--fluid kt-grid kt-error-v4"
          style={{
            backgroundImage: `url(${toAbsoluteUrl("/media//error/bg4.jpg")})`
          }}
        >
          <div className="kt-error_container">
          <h1 className="kt-error_number">404</h1>
            <p className="kt-error_title">ERROR</p>
            <p className="kt-error_description">Nothing left to do here.</p>
          </div>
        </div>
      </div>
    </>
  );
}
